import type { Options } from 'linkifyjs'
import linkifyHtml from 'linkify-html'

export function linkify(content: string): string {
  const options: Partial<Options> = {
    attributes: null,
    className: 'message-link', // FIXME: Should be a parameter
    defaultProtocol: 'http',
    events: undefined,
    format: (value: string) => {
      // TODO: FIXME: Replace with `truncate` option
      return value.length > 30 ? value.slice(0, 30) + '…' : value
    },
    formatHref: {},
    ignoreTags: ['script', 'style'],
    nl2br: true,
    rel: null,
    tagName: 'a',
    target: {
      url: '_blank',
    },
    truncate: 0,
    validate: null,
  }

  return linkifyHtml(content, options)
}
